import { render } from "./App.vue?vue&type=template&id=077ceec4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=077ceec4&lang=css"

import exportComponent from "F:\\PROJECTS\\2022\\delish\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__